export const common = {
    companyName: '小松彈簧工業株式會社',
    companyNameEn: 'Komatsu Spring Industrial Co., Ltd.',
    slogan: '精細的構思',
    heroTagline: '以品質取勝的彈簧專家',
    heroSubtitle: '透過精密彈簧的訂單生產，滿足客戶的每一項需求',
    productInfo: '產品介紹',
    companyProfile: '公司介紹',
    blog: '部落格',
    contact: '聯絡我們',
    recruit: '招募資訊',
    news: '最新消息',
    newsAll: '查看全部消息',
    torsionSpring: '扭轉彈簧',
    compressionSpring: '壓縮彈簧',
    tensionSpring: '拉伸彈簧',
    wireForming: '線材成型加工',
    torsionSpringEn: 'TORSION SPRING',
    compressionSpringEn: 'COMPRESSION SPRING',
    tensionSpringEn: 'TENSION SPRING',
    wireFormingEn: 'WIRE FORMINGS',
    address: '〒143-0013 東京都大田區大森南5丁目3番18號',
    tel: '電話: 03-3743-0231(總機)',
    fax: '傳真: 03-3743-0235',
    copyright: '© Komatsu Spring Industrial Co., Ltd.',
    features: '公司特色',
    springTypes: '彈簧種類',
    products: '產品',
    usage: '用途',
    message: '總經理致辭',
    companySummary: '公司概要',
    equipment: '設備',
    office: '辦事處',
    history: '公司歷史',
    quality: '品質方針/環境方針',
    esg: 'ESG',
    registrations: '註冊・會員團體',
    japanese: '日本語',
    english: 'English',
    chinese: '中文(简体)',
    chineseTraditional: '中文(繁體)',
    
    // Footer translations
    companyAddress: '〒143-0013 東京都大田區大森南5丁目3番18號',
    quickLinks: '快速連結',
    home: '首頁',
    featuresTitle: '公司特色',
    businessHours: '營業時間',
    businessHoursDetail: '週一至週五 8:30-17:30（週六、週日、節假日休息）',
    
    // Features page content
    featuresSubtitle: '我們引以為傲的高品質彈簧，源於精細的構思和徹底的客戶至上主義。',
    delicateDesign: '精細的構思',
    delicateDesignDesc: '基於「即使是一個小彈簧，也是構成精密產品心臟部分的重要部件」的理念進行技術開發。',
    prototypeToMass: '從樣品到批量生產',
    prototypeToMassDesc1: '從1個樣品開始承接訂單。',
    prototypeToMassDesc2: '從樣品開始就使用機械設備製造，確保批量生產時的同等品質。',
    qualityControl: '徹底的品質管理',
    qualityControlDesc1: '在工廠內建立品質:',
    qualityControlDesc1Detail: '從產品接單到製造直至交付的各個工序中，建立徹底的管理和檢查體制，實現更完善的產品製造。',
    qualityControlDesc2: '品質保證:',
    qualityControlDesc2Detail: '在產品交付時提供保證可靠品質的「產品檢查成績表」。',
    qualityControlDesc3: '交期管理:',
    qualityControlDesc3Detail: '運用電腦進行徹底的交期管理。',
    qualityControlDesc4: '品質維持:',
    qualityControlDesc4Detail: '公司內部製作治具工具類、模具，能夠維持高精度的品質。',
    // Products page content
    productsTitle: '彈簧種類·產品·用途',
    productsSubtitle: '1000種需求，1000種技術',
    detailInfo: '詳細資訊和影片可透過以下連結查看。',
    torsionSpringDetail: '扭轉彈簧',
    compressionSpringDetail: '壓縮彈簧',
    tensionSpringDetail: '拉伸彈簧',
    wireFormingDetail: '線材成型加工',
    microSpring: '微細彈簧·醫療用特殊彈簧',
    otherProducts: '其他·工業產品以外',
    torsionSpringDesc: '扭轉彈簧是圍繞線圈中心軸承受扭轉載荷(扭矩)的彈簧。',
    torsionSpringSpec: '製造實績:線徑0.03㎜〜2.0㎜左右 圓線',
    compressionSpringDesc: '一般稱為壓簧的這種彈簧，壓縮載荷(線圈軸載荷)與撓度成正比。',
    compressionSpringSpec1: '製造實績:線徑0.02㎜〜2.0㎜ 圓線、扁線',
    compressionSpringSpec2: '形狀實績:長卷線圈、圓錐形、桶形、不等節距、不等外徑',
    tensionSpringDesc: '拉伸螺旋彈簧本質上與壓縮彈簧相同。(線圈部分通常為密繞)',
    tensionSpringSpec: '製造實績:線徑0.08㎜〜2.0㎜左右',
    wireFormingDesc: '使用成型機等設備進行各種成型加工的「線工藝彈簧」',
    wireFormingSpec1: '製造實績:線徑0.1㎜〜2㎜左右',
    wireFormingSpec2: '材料形狀:圓線、扁線',
    materials: '材料',
    materialTypes: '鋼琴線、不鏽鋼線、鉑金線、磷青銅線、各種鍍層線、其他',
    materialShapes: '圓線、扁線',
    builtInProducts: '組裝產品實例',
    builtInProductsSubtitle: '被用於各種產品中',
    electricalProducts: '電氣產品',
    electricalProductsList: '工業產品、家電、相機、印表機、燃氣設備、火災警報器、電錶、其他',
    communication: '通訊',
    communicationList: '手機、充電台、接線端子、時鐘、其他',
    medicalEquipment: '醫療器械',
    medicalEquipmentList: '導管治療器、內視鏡裝置、電刀、活檢用設備、健康器具、脈搏血氧儀、血壓計、體重計、計步器、理容器械、其他',
    vehicleEquipment: '車輛設備',
    vehicleEquipmentList: '汽車、摩托車、割草機、巴士、其他',
    otherUsage: '其他',
    otherUsageList: '珠寶、鎖具、音響設備、釣具、文具、玩具、傢俱、其他',
    usageTitle: '用途',
    usageSubtitle: '針對每個用途的專門技術應對',
    electricalUsage: '開關、連接器、電池導電用、導電部件、接觸探針、印表機點陣針、感測器、其他',
    communicationUsage: '手錶錶冠、手錶日曆、鉸鏈、天線、相機快門、相機鏡頭周邊、其他',
    medicalUsage: '導絲用、內視鏡插入部用、投影用標記、夾子、活檢機用、其他',
    vehicleUsage: '化油器、車內電裝部件用、煞車開關、其他',
    otherDetailUsage: '過濾器、固定件、耳環、唱針臂支撐、擬餌框架、捲軸、文具夾、原子筆部件、其他',
    
    // Product detail pages common
    banner: '全部訂製生產的精密設備微觀科學',
    clickToEnlarge: '點擊放大顯示',
    manufacturingRecord: '製造實績',
    characteristics: '特徵',
    mainApplications: '主要用途',
    technicalSpecs: '技術規格',
    qualityAssurance: '品質保證',
    contactUs: '聯絡我們',
    
    // Torsion Spring page
    torsionSpringApp1: '汽車門鉸鏈',
    torsionSpringApp2: '洗衣機蓋開閉機構',
    torsionSpringApp3: '電子設備蓋開閉',
    torsionSpringApp4: '手錶上弦機構',
    torsionSpringApp5: '玩具驅動部件',
    
    // Compression Spring page
    compressionSpringFeature: '壓縮彈簧是最常見的彈簧之一，具有在軸向壓縮載荷作用下收縮的特性。載荷與撓度成正比關係，被用於各種機械部件和電子設備中。',
    compressionSpringApp1: '汽車懸吊',
    compressionSpringApp2: '原子筆內部機構',
    compressionSpringApp3: '電子設備開關',
    compressionSpringApp4: '醫療設備部件',
    compressionSpringApp5: '工業機械緩衝材料',
    hardWire: '硬鋼線（SWC）',
    flatWire: '扁線材料',
    specialShapes: '特殊形狀對應',
    conicalSpring: '圓錐彈簧（錐形線圈）',
    barrelSpring: '桶形彈簧',
    unevenPitch: '不等節距彈簧',
    unevenDiameter: '不等外徑彈簧',
    longCoil: '長卷線圈',
    squareWireSpring: '方線彈簧',
    precisionMeasurement: '精密測量',
    precisionMeasurementDesc: '使用千分尺級精密測量設備',
    loadTest: '載荷試驗',
    loadTestDesc: '對所有批次進行彈簧載荷試驗',
    qualityCertificate: '品質保證書',
    qualityCertificateDesc: '發行附帶檢查資料的品質保證書',
    
    // Tension Spring page
    tensionSpringFeature: '拉伸彈簧具有在軸向拉伸載荷作用下伸長的特性。線圈部分通常為密繞，兩端加工成鉤狀。適用於利用與壓縮彈簧相反方向力的用途。',
    tensionSpringApp1: '測量儀錶指針復位機構',
    tensionSpringApp2: '閉門器',
    tensionSpringApp3: '電子部件連接機構',
    tensionSpringApp4: '醫療設備操作部件',
    tensionSpringApp5: '汽車電纜',
    hookTypes: '鉤形狀種類',
    roundHook: '圓鉤',
    roundHookDesc: '最常見的圓形鉤形狀',
    angleHook: '角鉤',
    angleHookDesc: '可調節角度的形狀',
    specialHook: '特殊鉤',
    specialHookDesc: '根據用途訂製的形狀',
    materialsList: '材料',
    pianoWire: '鋼琴線（SWP-A, SWP-B）',
    stainlessWire: '不鏽鋼線（SUS304, SUS316）',
    phosphorBronze: '磷青銅線',
    berylliumCopper: '鈹銅線',
    specialAlloy: '其他特殊合金線',
    processingRange: '加工範圍',
    wireDiameter: '線徑',
    outerDiameter: '外徑',
    freeLength: '自由長度',
    effectiveCoils: '有效圈數：可協商',
    hookAccuracy: '鉤精度',
    hookAccuracyDesc: '嚴格管理鉤形狀的尺寸精度',
    tensileTest: '拉伸試驗',
    tensileTestDesc: '對所有產品進行規定載荷的拉伸試驗',
    durabilityTest: '耐久性試驗',
    durabilityTestDesc: '透過重複載荷確認耐久性',
    
    // Wire Forming page
    wireFormingFeature: '線材成型加工是將線材成型為各種形狀的技術。使用成型機，高精度製造複雜的三維形狀部件。也稱為「線工藝彈簧」，可應對多樣化用途。',
    wireFormingApp1: '夾子、訂書釘',
    wireFormingApp2: '電子部件連接端子',
    wireFormingApp3: '醫療設備精細部件',
    wireFormingApp4: '手錶·精密儀器部件',
    wireFormingApp5: '裝飾品·配飾',
    processingTypes: '加工種類',
    bendingProcess: '彎曲加工',
    bendingProcessDesc: '將直線材料彎曲成任意角度的加工',
    coilingProcess: '捲繞加工',
    coilingProcessDesc: '捲繞成螺旋狀或線圈狀',
    cuttingProcess: '切斷加工',
    cuttingProcessDesc: '按指定尺寸精密切斷',
    formingProcess: '成型加工',
    formingProcessDesc: '複合三維形狀的成型',
    supportedMaterials: '對應材料',
    highCarbonWire: '鋼琴線（高碳鋼線）',
    stainlessVariety: '各種不鏽鋼線',
    copperWire: '銅線·黃銅線',
    titaniumWire: '鈦線',
    platedWire: '各種鍍層線',
    materialShape: '材料形狀：圓線、扁線',
    processingLength: '加工長度',
    accuracy: '精度',
    minBendRadius: '最小彎曲半徑：線徑的1.5倍',
    applicationFields: '應用領域',
    electronicPrecision: '電子·精密設備',
    connectionTerminals: '連接端子·連接器',
    sensorParts: '感測器部件',
    boardFixing: '電路板固定部件',
    switchMechanism: '開關機構',
    medicalDevices: '醫療設備',
    catheterParts: '導管部件',
    endoscopeParts: '內視鏡用部件',
    surgicalInstruments: '外科器械',
    inspectionParts: '檢查設備部件',
    autoIndustrial: '汽車·產業設備',
    electricalParts: '電裝部件',
    fixingClips: '固定夾',
    mechanismParts: '機構部件',
    dimensionInspection: '尺寸檢查',
    dimensionInspectionDesc: '使用三維測量設備進行精密尺寸檢查',
    appearanceInspection: '外觀檢查',
    appearanceInspectionDesc: '表面品質·形狀精度的全數檢查',
    functionalTest: '功能試驗',
    functionalTestDesc: '實際使用條件下的動作確認試驗',
    
    // Micro Spring page
    microSpringDesc: '從超小型彈簧到醫療設備專用特殊彈簧，採用高精度技術製造。',
    microSpringTitle: '微細彈簧',
    microSpringEn: 'MICRO SPRING',
    medicalSpringTitle: '醫療用特殊彈簧',
    medicalSpringEn: 'MEDICAL SPECIAL SPRING',
    microFeature1: '使用線徑0.02mm起的超細線材',
    microFeature2: '外徑1mm以下的超小型彈簧',
    microFeature3: '最適合精密電子設備',
    microFeature4: '高精度尺寸管理',
    microApp1: '手錶內部機構',
    microApp2: '精密測量儀器',
    microApp3: '相機機構部件',
    microApp4: '微型開關',
    medicalFeature1: '使用生物相容性材料',
    medicalFeature2: '高安全性和可靠性',
    medicalFeature3: '訂製設計對應',
    medicalFeature4: '嚴格的品質管理',
    medicalApp1: '導管部件',
    medicalApp2: '內視鏡設備',
    medicalApp3: '外科用器械',
    medicalApp4: '生物感測器',
    microSpringSpecs: '微細彈簧規格',
    medicalMaterials: '醫療用材料',
    biocompatibleStainless: '生物相容性不鏽鋼',
    titaniumAlloy: '鈦合金：輕量·高強度材料',
    mp35n: 'MP35N：高性能合金',
    platinumWire: '鉑金線：高純度材料',
    manufacturingProcess: '製造工藝',
    materialSelection: '材料選定',
    materialSelectionDesc: '根據用途選定和驗證最佳材料',
    precisionProcessing: '精密加工',
    precisionProcessingDesc: '使用專用設備進行高精度成型加工',
    qualityInspection: '品質檢查',
    qualityInspectionDesc: '尺寸·載荷·外觀的全數檢查',
    cleanPackaging: '清潔包裝',
    cleanPackagingDesc: '在潔淨室環境中進行最終包裝',
    electronicDevices: '電子設備',
    electronicDevicesDesc: '智慧型手機、平板電腦、可穿戴設備的內部部件',
    medicalEquipmentDesc: '導管、內視鏡、外科器械、檢查設備',
    precisionInstruments: '精密儀器',
    precisionInstrumentsDesc: '手錶、測量儀器、光學設備的精密部件',
    opticalEquipment: '光學設備',
    opticalEquipmentDesc: '相機、顯微鏡、鏡頭驅動機構',
    automationEquipment: '自動化設備',
    automationEquipmentDesc: '機器人、精密執行器',
    analyticalInstruments: '分析儀器',
    analyticalInstrumentsDesc: '分析裝置、檢查裝置的微細部件',
    certifications: '品質保證·認證',
    isoCertification: 'ISO認證',
    isoCertificationDesc: '符合國際品質管理標準',
    precisionInspectionTitle: '精密檢查',
    precisionInspectionDesc: '使用最新測量設備進行全數檢查',
    traceability: '可追溯性',
    traceabilityDesc: '製造履歷的完全管理',
    medicalCertification: '醫療認證',
    medicalCertificationDesc: '醫療設備用材料認證',
    
    // Other Products page
    otherProductsDesc: '除工業產品外，還製造日常生活中使用的各種產品的彈簧部件。',
    jewelryAccessories: '珠寶·配飾',
    earringClasp: '耳環·耳釘的扣件',
    necklaceClasp: '項鍊扣',
    broochClasp: '胸針扣',
    watchBandParts: '錶帶部件',
    stationery: '文具',
    penMechanism: '原子筆內部機構',
    clipsBindings: '夾子·活頁夾',
    mechanicalPencil: '自動鉛筆部件',
    staplerParts: '訂書機機構部件',
    toysHobbies: '玩具·愛好',
    toyMechanism: '玩具驅動機構',
    modelParts: '模型可動部件',
    fishingReelParts: '釣具捲軸部件',
    lureFrame: '擬餌框架',
    furnitureInterior: '傢俱·室內裝飾',
    chairCushion: '椅子座墊',
    sofaStructure: '沙發內部結構',
    drawerMechanism: '抽屜開閉機構',
    doorCloser: '閉門器',
    audioEquipment: '音響設備',
    recordNeedleArm: '唱針臂支撐',
    speakerDiaphragm: '揚聲器振膜',
    instrumentParts: '樂器部件',
    headphoneAdjustment: '耳機調節機構',
    securityLocks: '鎖具·安全',
    lockMechanism: '鎖內部機構',
    padlockParts: '掛鎖部件',
    doorLock: '門鎖機構',
    securityDevice: '安全裝置',
    manufacturingFeatures: '製造特點',
    customDesign: '訂製設計',
    customDesignDesc: '根據客戶用途進行完全訂製設計。提供兼顧設計性和功能性的產品。',
    diverseFinishes: '多樣化表面處理',
    diverseFinishesDesc: '對應電鍍、塗裝、研磨等各種表面處理。實現美觀外觀和耐久性。',
    smallLotSupport: '小批量對應',
    smallLotSupportDesc: '從樣品到小批量生產靈活對應。也接受個人客戶的訂單。',
    shortDelivery: '短交期',
    shortDeliveryDesc: '憑藉豐富經驗和高效生產體制，可實現短交期交付。',
    usedMaterials: '使用材料',
    metalMaterials: '金屬材料',
    brassWire: '黃銅線',
    surfaceTreatment: '表面處理',
    goldPlating: '鍍金',
    silverPlating: '鍍銀',
    nickelPlating: '鍍鎳',
    chromePlating: '鍍鉻',
    variousPainting: '各種塗裝',
    specialMaterials: '特殊材料',
    colorWire: '彩色線材',
    otherConsultation: '其他可協商',
    qualityService: '品質與服務',
    designConsultation: '設計諮詢',
    designConsultationDesc: '專業人員從設計階段開始提供支援',
    prototypeSupport: '樣品對應',
    prototypeSupportDesc: '從1個開始可製作樣品',
    qualityGuarantee: '品質保證',
    qualityGuaranteeDesc: '透過全數檢查進行品質保證',
    rapidDelivery: '快速配送',
    rapidDeliveryDesc: '短交期製造·配送',
    contactMessage: '歡迎隨時諮詢',
    contactSubMessage: '再小的諮詢我們也會認真對待',
    
    // Contact page
    'contact.title': '聯絡我們',
    'contact.subtitle': '關於彈簧的任何問題都可以諮詢我們',
    'contact.intro1': '全部採用訂製生產，從樣品到批量生產均可對應。',
    'contact.intro2': '如有圖紙或實物，請告知我們。',
    'contact.requiredNote': '※ 請填寫所有帶星號的項目。',
    'contact.formTitle': '聯絡表單',
    'contact.companyName': '公司名稱',
    'contact.department': '部門名稱',
    'contact.fullName': '姓名',
    'contact.address': '地址',
    'contact.telephone': '電話號碼',
    'contact.email': '電子郵箱',
    'contact.specification': '規格',
    'contact.preferredDeliveryDate': '希望交貨日期',
    'contact.preferredUnitPrice': '希望單價',
    'contact.characters': '字',
    'contact.submit': '提交',
    'contact.submitting': '提交中...',
    'contact.submitSuccess': '已收到您的諮詢。謝謝。',
    'contact.submitError': '提交失敗。請重試。',
    'contact.requiredFields': '請填寫所有必填項。',
    'contact.specificationLimit': '請在500字以內輸入規格。',
    'contact.urgentContact': '如有緊急情況',
    'contact.urgentContactDesc': '也可透過電話和傳真聯絡。',
    'contact.phone': '電話',
    'contact.fax': '傳真',
    
    // Recruit page
    'recruit.title': '招募資訊',
    'recruit.subtitle': '尋找具有彈性和靈活思維的人才',
    'recruit.intro': '我們尋找像彈簧一樣具有彈性和靈活思維的人才。也歡迎希望回鄉就業的人士諮詢。',
    'recruit.jobListings': '招募要求',
    'recruit.tokyoOffice': '東京總部工廠',
    'recruit.ogawaraFactory': '大河原工廠',
    'recruit.akitaFactory': '秋田太田町工廠',
    'recruit.location': '工作地點',
    'recruit.positions': '招募人數',
    'recruit.salary': '起薪',
    'recruit.person': '名',
    'recruit.yen': '日圓',
    'recruit.university': '大學畢業',
    'recruit.technical': '高等專科學校、專門學校畢業',
    'recruit.highSchool': '高中畢業',
    'recruit.graduate': '研究生院',
    'recruit.tokyoAddress': '東京都大田區大森南5丁目3番18號',
    'recruit.ogawaraAddress': '宮城縣柴田郡大河原町字甲子町1-1',
    'recruit.akitaAddress': '秋田縣大仙市太田町斉內字北開182-4',
    'recruit.commonInfo': '共通',
    'recruit.salaryIncrease': '加薪',
    'recruit.salaryIncreaseDetail': '每年一次（4月）',
    'recruit.bonus': '獎金',
    'recruit.bonusDetail': '每年兩次（7月、12月）：根據業績',
    'recruit.workingHours': '工作時間',
    'recruit.workingHoursDetail': '8:30〜17:30（含70分鐘休息）根據工作地點和部門可能有所不同',
    'recruit.holidays': '休息日',
    'recruit.holidaysDetail1': '每週休息兩天',
    'recruit.holidaysDetail2': '年休息日數 113天（根據公司日曆）',
    'recruit.vacation': '假期',
    'recruit.vacationDetail1': '年度帶薪假期（按法定）',
    'recruit.vacationDetail2': '特別假期（結婚、喪假、赴任、生育等）',
    'recruit.jobType': '職種',
    'recruit.jobTypeDetail': '生產技術、開發、生產管理（資材採購、外包管理、品質/工序管理等）、事務（營業、總務）',
    'recruit.benefits': '福利待遇等',
    'recruit.benefitsDetail': '各種社會保險齊全、退休金制度、企業年金制度、資格取得支援制度、資格取得時獎勵金制度、簡易保險（日本郵政）、育兒休職制度、生日禮物等',
    'recruit.companyVideo': '公司介紹影片',
    'recruit.videoNotSupported': '您的瀏覽器不支援影片標籤。',
    'recruit.applicationForm': '應徵表單',
    'recruit.fullName': '姓名',
    'recruit.email': '電子郵箱',
    'recruit.telephone': '電話號碼',
    'recruit.address': '地址',
    'recruit.education': '最終學歷',
    'recruit.selectEducation': '請選擇',
    'recruit.desiredPosition': '希望職位',
    'recruit.desiredLocation': '希望工作地點',
    'recruit.selectLocation': '請選擇',
    'recruit.message': '自我介紹・應徵動機',
    'recruit.characters': '字',
    'recruit.submit': '應徵',
    'recruit.submitting': '提交中...',
    'recruit.submitSuccess': '感謝您的應徵。負責人將與您聯絡。',
    'recruit.submitError': '提交失敗。請重試。',
    'recruit.requiredFields': '請填寫所有必填項。',
    'recruit.messageLimit': '請在500字以內輸入資訊。',
    'recruit.contactInfo': '聯絡方式',
    'recruit.contactAddress': '〒143-0013 東京都大森南5丁目3番18號',
    'recruit.contactDepartment': '東京總部 總務部',
    'recruit.contactTel': 'Tel: 03-3743-0231（總機）',
    'recruit.contactFax': 'Fax: 03-3743-0235',
    
    // Company Message page
    'message.title': '總經理致辭',
    'message.subtitle': '致力於成為客戶需要的公司',
    'message.greeting': '感謝您訪問我們的網站。',
    'message.content1': '小松彈簧工業株式會社創立於1941年，1952年成立公司。作為精密彈簧的專業製造商，我們已有80多年的歷史。',
    'message.content2': '我們的企業理念是「被客戶需要」。為了實現這一目標，我們始終貫徹「客戶至上主義」，致力於製造高品質的彈簧。',
    'message.content3': '彈簧雖然是小部件，但在各種產品中發揮著重要作用。從工業設備到醫療器械、電子設備、日用品，我們的彈簧被應用於廣泛的領域。',
    'message.content4': '我們從1個樣品到批量生產都可承接訂單，靈活應對客戶需求。同時，我們也建立了維持穩定品質和遵守交貨期的體制。',
    'message.content5': '今後，我們將繼續提高技術水平，提供讓客戶滿意的產品。敬請繼續支持。',
    'message.president': '代表董事社長',
    'message.presidentName': '小松 萬希子',
    
    // Company Office page
    'office.title': '辦事處',
    'office.subtitle': '全國生產·銷售網路',
    'office.tokyoTitle': '東京總部工廠',
    'office.tokyoAddress': '〒143-0013 東京都大田區大森南5丁目3番18號',
    'office.tokyoTel': 'Tel: 03-3743-0231（總機）',
    'office.tokyoFax': 'Fax: 03-3743-0235',
    'office.tokyoAccess': '交通',
    'office.tokyoAccessDetail': 'JR大森站步行15分鐘 / 京急立會川站步行10分鐘',
    'office.ogawaraTitle': '大河原工廠',
    'office.ogawaraAddress': '〒989-1246 宮城縣柴田郡大河原町字甲子町1-1',
    'office.ogawaraTel': 'Tel: 0224-53-2336',
    'office.ogawaraFax': 'Fax: 0224-53-2337',
    'office.ogawaraAccessDetail': 'JR大河原站開車5分鐘',
    'office.akitaTitle': '秋田太田町工廠',
    'office.akitaAddress': '〒019-1601 秋田縣大仙市太田町斉內字北開182-4',
    'office.akitaTel': 'Tel: 0187-88-1333',
    'office.akitaFax': 'Fax: 0187-88-1334',
    'office.akitaAccessDetail': 'JR上境站開車10分鐘',
    
    // Company History page
    'history.title': '公司歷史',
    'history.subtitle': '80多年的歷史與傳統',
    'history.1941': '1941年5月：在東京都大田區大森創立小松彈簧製作所',
    'history.1952': '1952年12月：成立小松彈簧工業株式會社',
    'history.1965': '1965年4月：在宮城縣設立大河原工廠',
    'history.1985': '1985年3月：設立秋田太田町工廠',
    'history.2002': '2002年2月：取得ISO 9001:2000認證',
    'history.2007': '2007年1月：取得Eco-Action 21認證',
    'history.2015': '轉換為ISO 9001:2015',
    'history.present': '現在：在全國運營3個工廠，製造精密彈簧',
    
    // Company CSR page
    'csr.title': '品質方針/環境方針',
    'csr.subtitle': '對品質和環境的承諾',
    'csr.qualityPolicyTitle': '品質方針',
    'csr.isoRegistration': '登記日期：2002年2月1日',
    'csr.isoNumber': '登記證號碼：JQA-QM7736',
    'csr.qualityContent1': '在小松彈簧工業株式會社實施的「彈簧」製造活動中，以「被客戶需要」為經營理念，在「徹底貫徹客戶至上主義」的基本方針下，繼續同時推進企業發展的原理「成長與擴大」和「穩定」。',
    'csr.qualityContent2': '今後的課題是隨著精密設備產業的快速發展，作為超精密彈簧製造企業提高技術和靈活的構思能力，實現品質的均一化、嚴守交貨期、成本的合理化，遵守確保企業存續所需的利潤。',
    'csr.qualityContent3': '制定包括符合客戶要求事項及持續改進品質管理體系有效性的承諾在內的品質方針。',
    'csr.qualityStatement': '「以滿足客戶要求為我公司的事業，持續提供名為信賴的產品」',
    'csr.qualityContent4': '這一品質方針是我公司事業的本質，基本是讓全體員工理解這一方針，確保能夠可靠地提供預期的產品和服務。每個人透過確實實施規定的事項並對活動負責，就能達成預期的成果。',
    'csr.qualitySignature': '小松彈簧工業株式會社 代表董事社長 小松萬希子',
    'csr.environmentalPolicyTitle': '環境經營方針',
    'csr.ecoRegistration': '認證·登記日期：2007年1月18日',
    'csr.ecoNumber': '認證號碼：0001270',
    'csr.philosophy': '1. 企業理念',
    'csr.philosophyStatement': '「被客戶需要」',
    'csr.philosophyContent': '為了我們能夠永恆，必須持續被客戶強烈需要。在任何環境下，透過以更優秀的技術製造更優秀的「彈簧」，我們透過企業為社會做貢獻。基於Eco-Action 21的理念，考慮「與地球共生」，明確我公司所有業務相關的環境影響，致力於環境友好型企業活動。',
    'csr.policy2': '2. 為了透過環境經營成長為更好的進化組織，整理今後經營中的課題（組織的外部、內部）和機會，透過克服課題成為事業發展的機會。根據事業內容、事業周邊狀況、事業與環境的關係而變化的課題和機會，必要時進行重新審視。',
    'csr.policy3': '3. 將企業理念與事業活動中的環境負荷相協調，確定應該著手的重點領域。',
    'csr.policy3Item1': '1) 透過削減電力、燃氣、汽油，抑制CO₂排放',
    'csr.policy3Item2': '2) 透過廢棄物分類·回收利用、削減紙張，抑制廢棄物排放',
    'csr.policy3Item3': '3) 透過節水等，削減使用量',
    'csr.policy3Item4': '4) 削減化學物質使用量',
    'csr.policy3Item5': '5) 透過原材料的高效使用，削減製造廢棄物',
    'csr.policy3Item6': '6) 推進綠色採購',
    'csr.policy3Item7': '7) 掌握產品含有化學物質，禁止含有、使用',
    'csr.policy4': '4. 透過環境經營活動，努力持續改進環境目標、環境計畫，提升環境經營水平。',
    'csr.policy5': '5. 承諾遵守環境相關法規。',
    'csr.policy6': '6. 利用公告、會議、晨會等，讓全體員工理解環境經營方針的內容並能夠著手實施。',
    'csr.co2Title': 'CO₂削減措施',
    'csr.co2Intro': '小松彈簧工業株式會社為實現可持續社會，積極致力於CO₂排放削減。我們認為環境保護是企業的責任，正在推進以下具體對策。',
    'csr.currentInitiatives': '當前措施',
    'csr.initiative1Title': '・將大河原工廠的電力100%切換為可再生能源',
    'csr.initiative1Detail': '透過使用可再生能源來源的電力，大幅削減了工廠運營伴隨的CO₂排放。',
    'csr.initiative2Title': '・全公司LED照明化',
    'csr.initiative2Detail': '引進比傳統照明耗電量少的LED，實現節能。',
    'csr.initiative3Title': '・引進電動汽車（1輛）',
    'csr.initiative3Detail': '將部分公司用車EV化，減輕移動伴隨的環境負擔。',
    'csr.initiative4Title': '・作為「HTT措施宣言企業（東京都）」的活動',
    'csr.initiative4Detail': '向東京都公開表明推進節能·創能·蓄能的姿態，強化措施。',
    'csr.initiative5Title': '・參加「大田Cool Action（大田區）」',
    'csr.initiative5Detail': '參加地區環境活動，與當地一起致力於可持續城市建設。',
    'csr.futureInitiatives': '今後計畫',
    'csr.future1Title': '・推進全公司向可再生能源計畫的轉換',
    'csr.future1Detail': '不僅是工廠，各事業所和辦公室也將切換為可再生能源。',
    'csr.future2Title': '・將總部空調設備更新為節能型',
    'csr.future2Detail': '將舊空調設備更換為高效節能型，削減使用電力。',
    'csr.conclusion': '透過這些活動，小松彈簧工業株式會社在將環境負擔降至最低的同時，為實現可持續未來做出貢獻。',
    
    // Company Overview page
    'overview.title': '公司概要',
    'overview.subtitle': '精密彈簧製造的專業企業',
    'overview.companyName': '公司名稱',
    'overview.companyNameValue': '小松彈簧工業株式會社',
    'overview.founded': '創業',
    'overview.foundedValue': '1941年5月',
    'overview.established': '設立',
    'overview.establishedValue': '1952年12月',
    'overview.capital': '資本金',
    'overview.capitalValue': '1,000萬日圓',
    'overview.headquarters': '本社所在地',
    'overview.headquartersValue': '〒143-0013 東京都大田區大森南5丁目3番18號',
    'overview.president': '代表董事社長',
    'overview.presidentValue': '小松 萬希子',
    'overview.products': '製造品目',
    'overview.productsValue': '各種精密彈簧（扭轉彈簧、壓縮彈簧、拉伸彈簧、線材成型加工品）',
    'overview.equipmentTitle': '主要設備',
    'overview.equipment1': '彈簧自動成型機',
    'overview.equipment1Detail': '最新型CNC彈簧成型機 20台',
    'overview.equipment2': '熱處理爐',
    'overview.equipment2Detail': '電氣爐、氣體爐 各種',
    'overview.equipment3': '研磨機',
    'overview.equipment3Detail': '端面研磨機、桶式研磨機',
    'overview.equipment4': '檢查器具',
    'overview.equipment4Detail': '載荷試驗機、三維測量儀、顯微鏡',
    'overview.equipment5': '工作機械',
    'overview.equipment5Detail': '車床、銑床、放電加工機',
  };
  